import styled from "styled-components";

export const IntegrationComponentMainDiv = styled.main``;

export const IntegrationComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 190px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .integration-hero-container {
    width: 100%;
    flex: 1;
    display: flex;
    gap: 10px;
    max-width: 1140px;
    align-items: center;
    justify-content: center;
  }
  .integration-hero-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    flex: 1;
    justify-content: space-between;
    gap: 10px;
  }
  .integration-hero-header-container {
    max-width: 470px;
    display: flex;
    gap: 40px;
  }
  .integration-hero-header-wrapper {
    display: flex;
    gap: 16px;
    flex-direction: column;
    width: 100%;
  }
  .integration-hero-header-text-wrapper {
    display: flex;
    gap: 24px;
    flex-direction: column;
  }
  .integration-hero-text-wrapper {
    > h1 {
      font-weight: 500;
      font-size: 60px;
      line-height: 1.1em;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
    }
    > p {
      font-size: 18px;
      line-height: 1.4em;
      opacity: 0.8;
    }
  }
  .integration-hero-left-container {
    width: 100%;
    flex: 1;
    border: 1px solid red;
    border-radius: 16px;
    display: flex;
    gap: 10px;
    max-width: 558px;
  }
  .integration-hero-image-container {
    height: 412px;
    flex: 1;
    width: 100%;
  }
`;

export const IntegrationComponentModelsDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    flex: 1;
    gap: 10px;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .integration-models-container {
    width: 100%;
    flex: 1;
    align-items: center;
    display: flex;
    gap: 10px;
    max-width: 1140px;
  }
  .integration-models-grid-container {
    flex: 1;
    grid-template-rows: repeat(2, min-content);
    grid-template-columns: repeat(3, minmax(50px, 1fr));
    grid-auto-rows: min-content;
    justify-content: center;
    gap: 24px;
    width: 100%;

    display: grid;
  }
`;

export const IntegrationComponentModelItemDiv = styled.div`
  width: 100%;
  height:100%;

  > div {
    width: 100%;
      height:100%;

  }
  .integration-model-container {
    border: 1px solid rgb(255 255 255 / 10%);
    background: rgb(255 255 255 / 2%);
    border-radius: 16px;
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    gap: 24px;
      height:100%;

    padding: 32px;
  }
  .integration-model-logo-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 16px;
    > img {
      border-radius: 16px;
    }
  }
  .integration-model-text-block {
    display: flex;
    flex-flow: column;
    gap: 16px;
  }
  .integration-model-text-wrapper {
    > h2 {
      font-size: 24px;
      line-height: 1.2em;
    }
    > p {
      font-size: 18px;
      line-height: 1.5em;
      opacity: 0.8;
    }
  }
`;
